document.addEventListener('DOMContentLoaded', function () {

  let viewportWidth = document.documentElement.clientWidth;

  //Add active item classes
  if(document.getElementById('myTabContent')) {
    document.getElementById('myTabContent').querySelector('.paragraph-tab:first-of-type').classList.add('active','show');
  }

  //This will only apply on mobile and tablet
  if (viewportWidth < 992) {

    if(document.getElementById('myTabContent')) {
      document.getElementById('myTabContent').querySelector('.mobile-button:first-of-type').classList.add('active');

      document.getElementById('myTabContent').querySelectorAll('.mobile-button').forEach(item => {
        item.addEventListener('click', event => {

          document.querySelectorAll('.paragraph-tab').forEach(item => {
            item.classList.remove('active','show');
          })

          document.querySelectorAll('.nav-link').forEach(item => {
            item.classList.remove('active');
          })

          let tabId = item.getAttribute('data-tab-id');
          let tab = document.getElementById(tabId);
          tab.click();
          item.classList.add('active');
        })

      })
    }
  }

}, false);

